import { useSelector } from "react-redux";

export default function useAuth(){
    const isLoggedIn = useSelector(state => state.userLoginStatus);
    

    // check in localstorage 
    
    // check in localstorage 

    // console.log("test-useAuth")
    const auth = isLoggedIn ; 
    return auth ; 
}